/*=========================================================================================
  File Name: module-agreement-actions.js
  Description: Agreement Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import AgreementAPI from '@/api/AgreementAPI.js';
export default {
	/**
	 * Kiểm tra user đã chấp nhận thỏa thuận sử dụng và quyền riêng tư chưa?
	 */
	checkAgreement: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: AgreementAPI.getAPIUrl() + `/checkagreement`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateAgreement', res.Data);
		}
		return res;
	},

	/**
	 * Lấy lịch sử
	 */
	viewHistoryAgreement: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: AgreementAPI.getAPIUrl() + `/viewhistory`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateLinkHistoryAgreement', res.Data);
		}
		return res;
	},

	/**
	 * Lấy link thỏa thuận và quyền riêng tư
	 */
	viewProductAgreement: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: AgreementAPI.getAPIUrl() + `/view`,
			params: payload
		});
		if (res && res.Data) {
			context.commit('updateProductAgreement', res.Data);
		}
		return res;
	},

	/**
	 * Lấy publish key cho SDK agreement
	 */
	getPublishKey: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: AgreementAPI.getAPIUrl() + '/publish-key'
		});
		return res;
	}
};
